// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"8faa67ac","187":"079c0961","769":"d30f4e18"}[chunkId] + ".chunk.css";
};